import "./App.css";
import "./index.css";
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import MainLayout from "./component/Layout/MainLayout";
// App content management

// Lazy Loaded Components
const Login = lazy(() => import("./component/Login/Login"));
const Dashboard = lazy(() => import("./component/Dashboard/DashboardMaster"));
const Appointments = lazy(() => import("./component/Appointments/AppointmentsMaster"));
const Queue = lazy(() => import("./component/Queue/QueueMaster"));
const WorkingHours = lazy(() => import("./component/Working_Hours/ViewWorkingHours"));
const WorkingHoursMaster = lazy(() => import("./component/Working_Hours/WorkingHoursMaster"));
const Revenue = lazy(() => import("./component/Revenue/RevenueMaster"));
const Notification = lazy(() => import("./component/Notification/Notification"));
import Profile from "./component/Profile/Profile";
const WalkinBooking = lazy(() => import("./component/Walkin_Booking/WalkinBookingMaster"));
const ManageServices = lazy(() => import("./component/Manage_Service/ManageServiceMaster"));
const AddService = lazy(() => import("./component/Manage_Service/AddService"));
const EditService = lazy(() => import("./component/Manage_Service/EditService"));
const EditWorkingHours = lazy(() => import("./component/Working_Hours/EditWorkingHours"));
const Forgot = lazy(() => import("./component/Login/Forget"));
const AppointmentsDetails = lazy(() => import("./component/Appointments/AppointmentsDetails"));
const HealthMetrics = lazy(() => import("./component/Appointments/HealthMetrics"));
const Report = lazy(() => import("./component/Appointments/Report"));
const UploadReport = lazy(() => import("./component/Appointments/UploadReport"));
const Prescription = lazy(() => import("./component/Appointments/Prescription"));
const ResetPassword = lazy(() => import("./component/Login/ResetPassword"));

// Logout Helper
export const logout = (history) => {
  Object.keys(Cookies.get()).forEach((c) => Cookies.remove(c));
  if (history) history.replace("/");
  else window.location.replace("/");
};

// Protected Route Wrapper
const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuth = !!Cookies.get("clinic_id");
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth ? (
          <MainLayout>
            <Component {...props} />
          </MainLayout>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

function App() {
  return (
    <Router>
      <Suspense fallback={
        <div className="h-screen w-full flex items-center justify-center bg-teal-50">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-teal-600"></div>
        </div>
      }>
        <Switch>
          {/* Public Routes */}
          <Route exact path="/" component={Login} />
          <Route exact path="/forgot" component={Forgot} />
          <Route exact path="/ResetPassword/:uuid" component={ResetPassword} />

          {/* Protected Routes */}
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <PrivateRoute exact path="/dashboard/appointments" component={Appointments} />
          <PrivateRoute exact path="/dashboard/queue" component={Queue} />
          <PrivateRoute exact path="/dashboard/workinghours/add" component={WorkingHoursMaster} />
          <PrivateRoute exact path="/dashboard/workinghours" component={WorkingHours} />
          <PrivateRoute exact path="/dashboard/workinghours/edit/:id" component={EditWorkingHours} />
          <PrivateRoute exact path="/dashboard/revenue" component={Revenue} />
          <PrivateRoute exact path="/dashboard/notification" component={Notification} />
          <PrivateRoute exact path="/dashboard/profile" component={Profile} />
          <PrivateRoute exact path="/dashboard/walkinbooking" component={WalkinBooking} />
          <PrivateRoute exact path="/dashboard/services" component={ManageServices} />
          <PrivateRoute exact path="/dashboard/services/add" component={AddService} />
          <PrivateRoute exact path="/dashboard/services/edit/:id" component={EditService} />
          <PrivateRoute exact path="/dashboard/appointments/details/:id" component={AppointmentsDetails} />
          <PrivateRoute exact path="/dashboard/appointments/healthmetrics/:patientId/:bookingId" component={HealthMetrics} />
          <PrivateRoute exact path="/dashboard/appointments/report/:patientId/:bookingId/:date" component={Report} />
          <PrivateRoute exact path="/dashboard/appointments/uploadreport/:patientId/:bookingId/:date/:frompage" component={UploadReport} />
          <PrivateRoute exact path="/dashboard/appointments/prescription/:patientId/:bookingId/:date/:isSendToPharm/:frompage" component={Prescription} />


          {/* Fallback */}
          <Redirect to="/" />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
